/* eslint-disable no-mixed-spaces-and-tabs */
import React, { useState, useContext, useCallback } from 'react';
import EditprofileDialog from './editProfile';
import './styles.css';
import HomeLayout from '../Layouts/homeLayout';
import { PayloadContext } from '../../context';
import { fullname } from '../helpers';
import { updateProfile } from '../../actions/userActions';
import { toast } from 'react-toastify';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import PersonalDetails from './personalDetails';
import ChangePassword from './changePassword';
// import Cropper from 'react-easy-crop';
import ImageCroper from '../common/imageCrop';
import { API_URL } from '../../config';
// import Compressor from 'compressorjs';

function Userprofile()
{
	const { payload, getPayload } = useContext(PayloadContext);

	const [ value, setValue ] = useState(0);
	const [ editprofileOpen, setEditprofileOpen ] = useState();
	// const [ file, setFile ] = useState({});
	const [ selImage, setImageCrop ] = useState(null);

	const handleClose = useCallback(() =>
	{
		setEditprofileOpen(false);
	}, []);

	const handleChange = (event, newValue) =>
	{
		setValue(newValue);
	};

	const handleSave = useCallback((body) =>
	{
		updateProfile(body).then((res) =>
		{
			// eslint-disable-next-line quotes, no-console
			// console.log('res === ', res);
			if (res.status)
			{
				toast.success('Updated successfully');
				setEditprofileOpen(false);
				getPayload(true);
			}
			else
			{
				toast.error('Please try again');
			}

		})
			.catch((err) =>
			{
				// eslint-disable-next-line quotes, no-console
				console.log('err ==== ', err);
				toast.error('Please try again');
			});
	}, [ getPayload ]);

	const onSelectFile = (e) =>
	{
		if (e.target.files && e.target.files.length > 0)
		{
			const reader = new FileReader();

			reader.addEventListener('load', () =>
				setImageCrop(reader.result)
			);
			reader.readAsDataURL(e.target.files[0]);
		}
	};

	  const handleCropCancel = () =>
	{
		setImageCrop(null);
	};

	const handleUploadImage = () =>
	{
		toast.success('Profile Image Updated successfully');
		setImageCrop(null);
		getPayload(true);
	};

	return (
		<div className='flexCol alignCntr '>
			<div className='flexCol alignCntr baseBg fullHeight pdngLG dashboardCntnr'>
				<div className='flexRow'>
					<h2>My profile</h2>
				</div>
				<div className='flexCol alignCntr pdngBMD'>
					<div className='avatarCntnr'>
						<div className='avatarImgCntnr'>
							<img id='preview' src={payload?.profilepic && payload?.profilepic !== '' ? `${API_URL}public/profilepics/${payload.profilepic}` : 'https://cdn.pixabay.com/photo/2017/11/10/05/48/user-2935527_960_720.png'} alt='profileImage' className='avatarImg' />
						</div>
						<div className='uploadInputCntnr'>
							<button className='uploadAvtrBtn'>
								<img src='https://cdn.pixabay.com/photo/2016/10/03/03/00/camera-1710849_960_720.png' className='uploadIcon invertWhite' alt='upload icon' />
							</button>
							<input
								className='uploadInputBtn'
								type='file' name='uploadfile'
								id='contained-button-file'
								accept='image/x-png,image/gif,image/jpeg,image/jpg'
								onChange={onSelectFile}
							/>
						</div>
					</div>
					{selImage !== null && (
						 <ImageCroper
							handleSetCroper={handleUploadImage}
							isOpen={selImage !== null}
							src={selImage}
							imageRatio={1 / 1}
							handleCancel={handleCropCancel}
						 />
					)}
					<span className='profileTxtLg'>{fullname(payload)}</span>
					<span className='profileTxtSM txtPrimary'>{payload?.email}</span>
				</div>
				{/* <div className='flexCol pdngSM'>
					<div className='flexRow pdngVMD'>
						<div className='flexMinWidthCol'>
							<h4>Personal Details</h4>
						</div>
						<div className='flexAutoCol'>
							<Button variant='outlined' size='small' color='primary'
							onClick={() => setEditprofileOpen(true)}>edit</Button>
						</div>
					</div>
					<div className='flexRow alignCntr pdngVXSM'>
						<span className='profileKeysTxtSM'>Name: </span>
						<span className='valTxtMD'> {fullname(payload)}</span>
					</div>
					<div className='flexRow alignCntr pdngVXSM'>
						<span className='profileKeysTxtSM'>Email: </span>
						<span className='valTxtMD txtPrimary'> {payload?.email}</span>
					</div>
					<div className='flexRow alignCntr pdngVXSM'>
						<span className='profileKeysTxtSM'>Phone: </span>
						<span className='valTxtMD'> {payload?.phone}</span>
					</div>
					{payload?.teamName && <div className='flexRow alignCntr pdngVXSM'>
						<span className='profileKeysTxtSM'>Team Name: </span>
						<span className='valTxtMD'> {payload?.teamName}</span>
					</div>}
					{payload?.companyName && <div className='flexRow alignCntr pdngVXSM'>
						<span className='profileKeysTxtSM'>Company Name: </span>
						<span className='valTxtMD'> {payload?.companyName}</span>
					</div>}
				</div> */}
				<div className='flexCol fullWidth pdngTSM'>
					<Tabs
						value={value}
						onChange={handleChange}
						indicatorColor='primary'
						textColor='primary'
					>
						<Tab label='Personal Details' />
						<Tab label='Change Password' />
					</Tabs>
				</div>
				{value === 0 &&
					<PersonalDetails
						payload={payload}
						setEditprofileOpen={setEditprofileOpen}
					/>}
				{value === 1 && <ChangePassword/>}
				{editprofileOpen &&
					<EditprofileDialog
						editprofileOpen={editprofileOpen}
						handleClose={handleClose}
						data={payload}
						handleSave={handleSave}
					/>}
			</div>
		</div>
	);
}

export default HomeLayout(Userprofile);